// extracted by mini-css-extract-plugin
export default {"dark":"Input_dark__KPTwb","light":"Input_light__wW2CX","common_input":"Input_common_input__8j8np","input":"Input_input__QhQsG","icon_wrapper":"Input_icon_wrapper__keYw-"};